import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar, NavDropdown, Nav } from "react-bootstrap";
import Cart from "../assets/images/icons/icon-cart.png";
import { LinkContainer } from "react-router-bootstrap";
import axios from "../axios";
import logo from "../assets/images/logo.png";
import { useCartStore } from "../store/useStore";
import { useTranslation } from "react-i18next";
import { ShowCheckout } from "../API/CheckoutAPI";
import { changeLanguage } from "i18next";
import ReactGA from "react-ga4";
import { trackLanguageChanged } from "../utils/mixpanel";

function HeaderInner({
  logo,
  headerName,
  color,
  bgColor,
  text,
  scan,
  languages,
  theme,
}) {
  const [orders, setOrders] = useState(0);
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const notHome = rawPath.split("/")[2];
  const [langs, setLangs] = useState([]);
  const sc = rawPath.includes("/restaurant-menu/categories");
  // console.log("notHome", rawPath.includes("/restaurant-menu/categories"));
  let show = false;
  const businessType = localStorage.getItem("businessType");
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // console.log("lang", i18n.language);
  const changeLang = (newLang) => {
    const previousLang = i18n.language;
    console.log(newLang, "lang");
    i18n.changeLanguage(newLang);
    ReactGA.event({
      category: "Change language",
      action: "Click",
      value: `the language: ${newLang}`,
    });

    // Track Language Changed in Mixpanel
    trackLanguageChanged({
      from_language: previousLang || "EN",
      to_language: newLang,
    });
  };
  const lang = sessionStorage.getItem("lang");
  // console.log("rawPath", rawPath);

  const isSelct = languages?.filter((language) => {
    if (language.is_selected == true) {
      return language;
    }
  });

  console.log("isSelct", isSelct);
  useEffect(() => {
    if (languages?.length && isSelct?.length === 0) {
      i18n.changeLanguage(languages[0].code);
    }
  }, [languages, isSelct]);
  // console.log("isSelct", isSelct);
  if (notHome == "qr-code" || sc) {
    show = true;
  }
  let checkLink = true;

  if (scan) {
    checkLink = false;
  }
  if (location.pathname.includes("/Checkout-dining")) {
    checkLink = false;
  }

  // console.log("logo",);
  const { cartCount, setCartCount } = useCartStore((state) => ({
    cartCount: state.cartCount,
    setCartCount: state.setCartCount,
  }));

  let roomNumber;
  let flattenedArray;
  let cart_count = 0;
  let check;
  if (room_uuid) {
    const { data, isLoading, error } = ShowCheckout(room_uuid);

    if (!isLoading) {
      check = data?.data?.data;
      // console.log("check", check);
      const tempItems = check?.order?.map((order) => {
        return order?.items.map((aa) => aa);
      });
      const combo_meal = 0;
      // console.log("combo_meal", combo_meal);
      if (tempItems) {
        flattenedArray = [].concat(...tempItems);
        // console.log("flattenedArray", flattenedArray);
        cart_count =
          flattenedArray?.length == 0
            ? 0
            : flattenedArray
                ?.map((item) => item?.quantity)
                .reduce((acc, curr) => (acc += curr));
        cart_count = cart_count + combo_meal;
      }
    }
  }

  // sessionStorage.setItem("lang", lang);
  return (
    <>
      <Navbar
        className={theme ? "nav_theme" : ""}
        style={{ backgroundColor: bgColor }}
      >
        <div className="d-flex align-items-center">
          {show ? (
            <NavDropdown
              style={{ width: "fit-content" }}
              title={
                isSelct && (
                  <>
                    <img
                      alt="United States"
                      className="flag"
                      src={isSelct[0]?.image}
                    />

                    <span style={{ color: color }}>{isSelct[0]?.code}</span>
                  </>
                )
              }
              id="basic-nav-dropdown"
              className=""
            >
              {languages?.map((language, idx) => {
                return (
                  <NavDropdown.Item
                    style={{ color: color }}
                    onClick={() => changeLang(language.code)}
                  >
                    <img
                      alt="United States"
                      className="flag"
                      src={language.image}
                    />
                    <span style={{ width: "fit-content" }}>
                      {language.code}
                    </span>
                  </NavDropdown.Item>
                );
              })}
              {/* <NavDropdown.Item
                style={{ color: color }}
                onClick={() => changeLang("en")}
              >
                <img
                  alt="United States"
                  className="flag"
                  src="data:image/svg+xml,<svg id='_2634451_ensign_flag_nation_states_icon_1_' data-name='2634451_ensign_flag_nation_states_icon (1)' xmlns='http://www.w3.org/2000/svg' width='12.675' height='7.362' viewBox='0 0 12.675 7.362'><rect id='Rectangle_87' data-name='Rectangle 87' width='12.619' height='0.567' transform='translate(0 6.795)' fill='%23cb001c'/><rect id='Rectangle_88' data-name='Rectangle 88' width='12.619' height='0.567' transform='translate(0 6.228)' fill='%23fff'/><rect id='Rectangle_89' data-name='Rectangle 89' width='12.619' height='0.567' transform='translate(0 5.662)' fill='%23cb001c'/><rect id='Rectangle_90' data-name='Rectangle 90' width='12.619' height='0.567' transform='translate(0 5.095)' fill='%23fff'/><rect id='Rectangle_91' data-name='Rectangle 91' width='12.619' height='0.567' transform='translate(0 4.53)' fill='%23cb001c'/><rect id='Rectangle_92' data-name='Rectangle 92' width='12.619' height='0.567' transform='translate(0 3.963)' fill='%23fff'/><path id='Path_137' data-name='Path 137' d='M0,0H12.619V.567H0Z' transform='translate(0 3.396)' fill='%23cb001c'/><rect id='Rectangle_94' data-name='Rectangle 94' width='12.619' height='0.567' transform='translate(0 2.83)' fill='%23fff'/><rect id='Rectangle_95' data-name='Rectangle 95' width='12.619' height='0.567' transform='translate(0 2.265)' fill='%23cb001c'/><rect id='Rectangle_96' data-name='Rectangle 96' width='12.619' height='0.567' transform='translate(0 1.698)' fill='%23fff'/><rect id='Rectangle_97' data-name='Rectangle 97' width='12.619' height='0.567' transform='translate(0 1.131)' fill='%23cb001c'/><rect id='Rectangle_98' data-name='Rectangle 98' width='12.619' height='0.567' transform='translate(0 0.564)' fill='%23fff'/><rect id='Rectangle_99' data-name='Rectangle 99' width='12.675' height='0.445' fill='%23cb001c'/><rect id='Rectangle_100' data-name='Rectangle 100' width='5.763' height='3.963' fill='%232a3560'/><path id='Path_87' data-name='Path 87' d='M12.907,124.4l.049.15h.155l-.126.091.047.15-.126-.094-.128.094.049-.15-.128-.091h.158Z' transform='translate(-12.387 -123.964)' fill='%23fff'/><path id='Path_88' data-name='Path 88' d='M12.907,151.2l.049.15h.155l-.126.094.047.148-.126-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-12.387 -150.103)' fill='%23fff'/><path id='Path_89' data-name='Path 89' d='M12.907,178.1l.049.15h.155l-.126.091.047.15-.126-.094-.128.094.049-.15-.128-.091h.158Z' transform='translate(-12.387 -176.34)' fill='%23fff'/><path id='Path_90' data-name='Path 90' d='M12.907,204.9l.049.15h.155l-.126.094.047.148-.126-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-12.387 -202.48)' fill='%23fff'/><path id='Path_91' data-name='Path 91' d='M12.907,231.8l.049.148h.155l-.126.094.047.15-.126-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-12.387 -228.717)' fill='%23fff'/><path id='Path_92' data-name='Path 92' d='M31.607,138.5l.049.15h.155l-.126.094.047.148-.126-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-30.626 -137.716)' fill='%23fff'/><path id='Path_93' data-name='Path 93' d='M31.607,165.4l.049.148h.155l-.126.094.047.15-.126-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-30.626 -163.953)' fill='%23fff'/><path id='Path_94' data-name='Path 94' d='M31.607,192.2l.049.15h.155l-.126.094.047.148-.126-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-30.626 -190.093)' fill='%23fff'/><path id='Path_95' data-name='Path 95' d='M31.607,219.1l.049.148h.155l-.126.094.047.15-.126-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-30.626 -216.33)' fill='%23fff'/><path id='Path_96' data-name='Path 96' d='M50.507,124.4l.049.15h.158l-.128.091.049.15-.128-.094-.128.094.049-.15-.128-.091h.158Z' transform='translate(-49.06 -123.964)' fill='%23fff'/><path id='Path_97' data-name='Path 97' d='M50.507,151.2l.049.15h.158l-.128.094.049.148-.128-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-49.06 -150.103)' fill='%23fff'/><path id='Path_98' data-name='Path 98' d='M50.507,178.1l.049.15h.158l-.128.091.049.15-.128-.094-.128.094.049-.15-.128-.091h.158Z' transform='translate(-49.06 -176.34)' fill='%23fff'/><path id='Path_99' data-name='Path 99' d='M50.507,204.9l.049.15h.158l-.128.094.049.148-.128-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-49.06 -202.48)' fill='%23fff'/><path id='Path_100' data-name='Path 100' d='M50.507,231.8l.049.148h.158l-.128.094.049.15-.128-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-49.06 -228.717)' fill='%23fff'/><path id='Path_101' data-name='Path 101' d='M69.207,138.5l.049.15h.158l-.128.094.049.148-.128-.091-.128.091.049-.148L69,138.65h.158Z' transform='translate(-67.299 -137.716)' fill='%23fff'/><path id='Path_102' data-name='Path 102' d='M69.207,165.4l.049.148h.158l-.128.094.049.15-.128-.094-.128.094.049-.15L69,165.548h.158Z' transform='translate(-67.299 -163.953)' fill='%23fff'/><path id='Path_103' data-name='Path 103' d='M69.207,192.2l.049.15h.158l-.128.094.049.148-.128-.091-.128.091.049-.148L69,192.35h.158Z' transform='translate(-67.299 -190.093)' fill='%23fff'/><path id='Path_104' data-name='Path 104' d='M69.207,219.1l.049.148h.158l-.128.094.049.15-.128-.094-.128.094.049-.15L69,219.248h.158Z' transform='translate(-67.299 -216.33)' fill='%23fff'/><path id='Path_105' data-name='Path 105' d='M88.2,124.4l.049.15h.158l-.128.091.049.15L88.2,124.7l-.126.094.049-.15L88,124.55h.158Z' transform='translate(-85.831 -123.964)' fill='%23fff'/><path id='Path_106' data-name='Path 106' d='M88.2,151.2l.049.15h.158l-.128.094.049.148L88.2,151.5l-.126.091.049-.148L88,151.35h.158Z' transform='translate(-85.831 -150.103)' fill='%23fff'/><path id='Path_107' data-name='Path 107' d='M88.2,178.1l.049.15h.158l-.128.091.049.15L88.2,178.4l-.126.094.049-.15L88,178.25h.158Z' transform='translate(-85.831 -176.34)' fill='%23fff'/><path id='Path_108' data-name='Path 108' d='M88.2,204.9l.049.15h.158l-.128.094.049.148L88.2,205.2l-.126.091.049-.148L88,205.05h.158Z' transform='translate(-85.831 -202.48)' fill='%23fff'/><path id='Path_109' data-name='Path 109' d='M88.2,231.8l.049.148h.158l-.128.094.049.15L88.2,232.1l-.126.094.049-.15L88,231.948h.158Z' transform='translate(-85.831 -228.717)' fill='%23fff'/><path id='Path_110' data-name='Path 110' d='M106.9,138.5l.049.15h.158l-.128.094.049.148-.128-.091-.126.091.047-.148-.126-.094h.158Z' transform='translate(-104.07 -137.716)' fill='%23fff'/><path id='Path_111' data-name='Path 111' d='M106.9,165.4l.049.148h.158l-.128.094.049.15-.128-.094-.126.094.047-.15-.126-.094h.158Z' transform='translate(-104.07 -163.953)' fill='%23fff'/><path id='Path_112' data-name='Path 112' d='M106.9,192.2l.049.15h.158l-.128.094.049.148-.128-.091-.126.091.047-.148-.126-.094h.158Z' transform='translate(-104.07 -190.093)' fill='%23fff'/><path id='Path_113' data-name='Path 113' d='M106.9,219.1l.049.148h.158l-.128.094.049.15-.128-.094-.126.094.047-.15-.126-.094h.158Z' transform='translate(-104.07 -216.33)' fill='%23fff'/><path id='Path_114' data-name='Path 114' d='M125.807,124.4l.049.15h.155l-.126.091.047.15-.126-.094-.128.094.049-.15-.128-.091h.158Z' transform='translate(-122.504 -123.964)' fill='%23fff'/><path id='Path_115' data-name='Path 115' d='M125.807,151.2l.049.15h.155l-.126.094.047.148-.126-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-122.504 -150.103)' fill='%23fff'/><path id='Path_116' data-name='Path 116' d='M125.807,178.1l.049.15h.155l-.126.091.047.15-.126-.094-.128.094.049-.15-.128-.091h.158Z' transform='translate(-122.504 -176.34)' fill='%23fff'/><path id='Path_117' data-name='Path 117' d='M125.807,204.9l.049.15h.155l-.126.094.047.148-.126-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-122.504 -202.48)' fill='%23fff'/><path id='Path_118' data-name='Path 118' d='M125.807,231.8l.049.148h.155l-.126.094.047.15-.126-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-122.504 -228.717)' fill='%23fff'/><path id='Path_119' data-name='Path 119' d='M144.507,138.5l.047.15h.158l-.126.094.047.148-.126-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-140.743 -137.716)' fill='%23fff'/><path id='Path_120' data-name='Path 120' d='M144.507,165.4l.047.148h.158l-.126.094.047.15-.126-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-140.743 -163.953)' fill='%23fff'/><path id='Path_121' data-name='Path 121' d='M144.507,192.2l.047.15h.158l-.126.094.047.148-.126-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-140.743 -190.093)' fill='%23fff'/><path id='Path_122' data-name='Path 122' d='M144.507,219.1l.047.148h.158l-.126.094.047.15-.126-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-140.743 -216.33)' fill='%23fff'/><path id='Path_123' data-name='Path 123' d='M163.407,124.4l.049.15h.158l-.128.091.049.15-.128-.094-.128.094.049-.15-.128-.091h.158Z' transform='translate(-159.178 -123.964)' fill='%23fff'/><path id='Path_124' data-name='Path 124' d='M163.407,151.2l.049.15h.158l-.128.094.049.148-.128-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-159.178 -150.103)' fill='%23fff'/><path id='Path_125' data-name='Path 125' d='M163.407,178.1l.049.15h.158l-.128.091.049.15-.128-.094-.128.094.049-.15-.128-.091h.158Z' transform='translate(-159.178 -176.34)' fill='%23fff'/><path id='Path_126' data-name='Path 126' d='M163.407,204.9l.049.15h.158l-.128.094.049.148-.128-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-159.178 -202.48)' fill='%23fff'/><path id='Path_127' data-name='Path 127' d='M163.407,231.8l.049.148h.158l-.128.094.049.15-.128-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-159.178 -228.717)' fill='%23fff'/><path id='Path_128' data-name='Path 128' d='M182.107,138.5l.049.15h.158l-.128.094.049.148-.128-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-177.417 -137.716)' fill='%23fff'/><path id='Path_129' data-name='Path 129' d='M182.107,165.4l.049.148h.158l-.128.094.049.15-.128-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-177.417 -163.953)' fill='%23fff'/><path id='Path_130' data-name='Path 130' d='M182.107,192.2l.049.15h.158l-.128.094.049.148-.128-.091-.128.091.049-.148-.128-.094h.158Z' transform='translate(-177.417 -190.093)' fill='%23fff'/><path id='Path_131' data-name='Path 131' d='M182.107,219.1l.049.148h.158l-.128.094.049.15-.128-.094-.128.094.049-.15-.128-.094h.158Z' transform='translate(-177.417 -216.33)' fill='%23fff'/><path id='Path_132' data-name='Path 132' d='M201.1,124.4l.049.15h.158l-.128.091.049.15-.128-.094-.126.094.047-.15-.126-.091h.158Z' transform='translate(-195.948 -123.964)' fill='%23fff'/><path id='Path_133' data-name='Path 133' d='M201.1,151.2l.049.15h.158l-.128.094.049.148-.128-.091-.126.091.047-.148-.126-.094h.158Z' transform='translate(-195.948 -150.103)' fill='%23fff'/><path id='Path_134' data-name='Path 134' d='M201.1,178.1l.049.15h.158l-.128.091.049.15-.128-.094-.126.094.047-.15-.126-.091h.158Z' transform='translate(-195.948 -176.34)' fill='%23fff'/><path id='Path_135' data-name='Path 135' d='M201.1,204.9l.049.15h.158l-.128.094.049.148-.128-.091-.126.091.047-.148-.126-.094h.158Z' transform='translate(-195.948 -202.48)' fill='%23fff'/><path id='Path_136' data-name='Path 136' d='M201.1,231.8l.049.148h.158l-.128.094.049.15-.128-.094-.126.094.047-.15-.126-.094h.158Z' transform='translate(-195.948 -228.717)' fill='%23fff'/></svg>"
                />{" "}
                <span>EN</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                style={{ color: color }}
                onClick={() => changeLang("ar")}
              >
                <img
                  alt="United States"
                  className="flag"
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/AE.svg"
                />
                <span>AR</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                style={{ color: color }}
                onClick={() => changeLang("fr")}
              >
                <img
                  alt="United States"
                  className="flag"
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg"
                />{" "}
                <span>FR</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                style={{ color: color }}
                onClick={() => changeLang("ru")}
              >
                <img
                  alt="United States"
                  className="flag"
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/RU.svg"
                />{" "}
                <span>RU</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                style={{ color: color }}
                onClick={() => changeLang("hi")}
              >
                <img
                  alt="United States"
                  className="flag"
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/IN.svg"
                />{" "}
                <span>HI</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                style={{ color: color }}
                onClick={() => changeLang("ch")}
              >
                <img
                  alt="United States"
                  className="flag"
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/CN.svg"
                />{" "}
                <span>CH</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                style={{ color: color }}
                onClick={() => changeLang("de")}
              >
                <img
                  alt="United States"
                  className="flag"
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/DE.svg"
                />{" "}
                <span>DE</span>
              </NavDropdown.Item> */}
            </NavDropdown>
          ) : (
            <button
              className="back-btn-container"
              onClick={() => {
                location.pathname.includes("/qr-scan")
                  ? navigate(-2)
                  : location.pathname.includes("/taxi")
                    ? navigate(`/${room_uuid}/qr-code`)
                    : navigate(-1);

                ReactGA.event({
                  category: "Back button",
                  action: "Click",
                  value: "back",
                });
              }}
            >
              <div className="back-btn">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  fill="none"
                  className="bi bi-chevron-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    stroke="none"
                    stroke-width="1.3"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z "
                  ></path>
                </svg>
                <p>{t("back")}</p>
              </div>
            </button>
          )}
        </div>
        {!theme && (
          <Navbar.Brand>
            <Link
              to={checkLink && `/${room_uuid}/qr-code`}
              onClick={() => {
                ReactGA.event({
                  category: "Click on logo",
                  action: "Click",
                  value: "Click on logo",
                });
              }}
            >
              <span
                style={
                  location.pathname === "/HealthcareOrder" ||
                  location.pathname === "/Healthcare"
                    ? {
                        width: "133px",
                        display: "block",
                        textAlign: "center",
                        whiteSpace: "break-spaces",
                        // color: color
                      }
                    : null
                }
              >
                {headerName ? (
                  t(`${headerName}`)
                ) : (
                  <>
                    {location.pathname === "/Restaurants"
                      ? "In Room Dining"
                      : ""}

                    {location.pathname === "/RestaurantOrderPlaced"
                      ? "Checkout"
                      : ""}

                    {location.pathname === "/Spa" ? "SALON AT HOME" : ""}
                    {location.pathname === "/SpaAddService"
                      ? "SALON AT HOME"
                      : ""}
                    {location.pathname === "/SpaOrderPlaced" ? "Checkout" : ""}

                    {location.pathname === "/Entertainment"
                      ? "Entertainment"
                      : ""}
                    {location.pathname === "/EntertainmentDetail"
                      ? "Entertainment"
                      : ""}
                    {location.pathname === "/EntertainmentOrderPlaced"
                      ? "Checkout"
                      : ""}

                    {location.pathname === "/CarRental" ? "Car Rental" : ""}
                    {location.pathname === "/CarRentalOrderPlaced"
                      ? "Checkout"
                      : ""}

                    {location.pathname === "/Flowers" ? "Flowers" : ""}
                    {location.pathname === "/FlowersSubMenu" ? "Flowers" : ""}
                    {location.pathname === "/FlowerOrderPayment"
                      ? "Flowers"
                      : ""}
                    {location.pathname === "/FlowerOrderPlaced"
                      ? "Checkout"
                      : ""}

                    {location.pathname === "/Pharmacy" ? "PHARMACY" : ""}
                    {location.pathname === "/PharmacySubMenu" ? "PHARMACY" : ""}
                    {location.pathname === "/PharmacyOrderPayment"
                      ? "Checkout"
                      : ""}
                    {location.pathname === "/PharmacyOrderPlaced"
                      ? "Checkout"
                      : ""}

                    {location.pathname === "/Laundry" ? "Laundry" : ""}
                    {location.pathname === "/LaundryOrderPayment"
                      ? "Laundry"
                      : ""}
                    {location.pathname === "/LaundryOrderPlaced"
                      ? "Checkout"
                      : ""}
                    {location.pathname === "/HouseKeeping"
                      ? "HOUSEKEEPING"
                      : ""}
                    {location.pathname === "/HKOrderPlaced" ? "Checkout" : ""}
                    {location.pathname === "/Concierge" ? "CONCIERGE" : ""}
                    {location.pathname === "/ConciergeOrder" ? "CONCIERGE" : ""}
                    {location.pathname === "/Healthcare"
                      ? "HealthCare & Wellness"
                      : ""}
                    {location.pathname === "/HealthcareOrder"
                      ? "HealthCare & Wellness"
                      : ""}
                    {location.pathname === "/HCOrderPlaced" ? "Checkout" : ""}

                    {location.pathname === "/RestaurantBooking"
                      ? "Restaurant Booking"
                      : ""}
                    {location.pathname === "/BookTable" ? "Book a Table" : ""}
                    {location.pathname === "/Taxi" ? "Taxi Booking" : ""}
                    {location.pathname === "/MyOrders" ? "My Orders" : ""}
                    {location.pathname === "/Feedback" ? "Send a Feedback" : ""}
                    {location.pathname === "/AboutUs" ? "About Us" : ""}
                  </>
                )}
              </span>
            </Link>

            {logo && logo != undefined && logo !== "" ? (
              <img
                src={logo}
                style={{
                  width: "100px",
                  height: "60px",
                  objectFit: "contain",
                }}
                alt="Logo"
              />
            ) : (
              ""
            )}
            {/* <h6>{text}</h6> */}
          </Navbar.Brand>
        )}
        {businessType != "Hospital" ? (
          scan == true ? (
            <LinkContainer to={``}>
              <Nav.Link className="cart-container mr-2">
                {/* <svg
                    class="order2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height=""
                    viewBox="0 0 50 50"
                  >
                    <g id="Group_38424" data-name="Group 38424" class="cls-1order2">
                      <path
                        id="Path_188"
                        class="cls-2order2"
                        data-name="Path 188"
                        d="M88.649,47.317a4.045,4.045,0,0,1-.527-.768,13.4,13.4,0,1,1-.338-3.138L89,34.385l.027-.2a18.8,18.8,0,0,0-26.107-2.437v4.342A7.377,7.377,0,0,1,59.5,42.3v15.2a18.818,18.818,0,0,0,30.938-.728V48.5A4.034,4.034,0,0,1,88.649,47.317Z"
                        transform="translate(-50.462 -23.834)"
                        fill="#0015b3"
                      ></path>
                      <path
                        id="Path_189"
                        class="cls-2order2"
                        data-name="Path 189"
                        d="M97.531,78.318A11.129,11.129,0,1,0,108.66,89.447,11.142,11.142,0,0,0,97.531,78.318Z"
                        transform="translate(-73.277 -66.864)"
                        fill="#0015b3"
                      ></path>
                      <path
                        id="Path_190"
                        class="cls-2order2"
                        data-name="Path 190"
                        d="M265.9,4.673a1.756,1.756,0,0,0-3.5-.234L259.841,23.51a1.756,1.756,0,0,0,1.74,1.99h1.03V45.956a1.671,1.671,0,0,0,3.342,0Z"
                        transform="translate(-220.358 -2.917)"
                        fill="#0015b3"
                      ></path>
                      <path
                        id="Path_191"
                        class="cls-2order2"
                        data-name="Path 191"
                        d="M10.177,10.556a1.139,1.139,0,0,0-2.279,0v6.3H6.228v-6.3a1.139,1.139,0,0,0-2.279,0v6.3H2.279v-6.3a1.139,1.139,0,0,0-2.279,0V20.835A5.1,5.1,0,0,0,3.418,25.64V51.469a1.671,1.671,0,0,0,3.342,0V25.64a5.1,5.1,0,0,0,3.418-4.806Z"
                        transform="translate(0 -8.43)"
                        fill="#0015b3"
                      ></path>
                    </g>
                  </svg> */}
              </Nav.Link>
            </LinkContainer>
          ) : (
            <LinkContainer
              to={`/${room_uuid}/Checkout`}
              onClick={() => {
                ReactGA.event({
                  category: "Click on cart",
                  action: "Click",
                  value: "Click on cart",
                });
              }}
            >
              <Nav.Link className="cart-container mr-2">
                <div className="cart-count">
                  <p className="count">{cart_count}</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33.853"
                  height="33.853"
                  viewBox="0 0 33.853 33.853"
                >
                  <g
                    id="Group_37949"
                    data-name="Group 37949"
                    transform="translate(-400 574)"
                  >
                    <path
                      id="Path_292"
                      data-name="Path 292"
                      d="M19.367,38.349A2.349,2.349,0,1,1,17.019,36,2.354,2.354,0,0,1,19.367,38.349Z"
                      transform="translate(395.676 -584.61)"
                      fill="none"
                    ></path>
                    <path
                      id="Path_293"
                      data-name="Path 293"
                      d="M36.7,38.349A2.352,2.352,0,1,1,34.349,36,2.36,2.36,0,0,1,36.7,38.349Z"
                      transform="translate(390.569 -584.61)"
                      fill="none"
                    ></path>
                    <path
                      id="Path_294"
                      data-name="Path 294"
                      d="M32.185,7.037a.929.929,0,0,0-.741-.367H9.722L9.3,5.324a.922.922,0,0,0-.621-.607L4.82,3.532a.944.944,0,1,0-.55,1.806l3.371,1.03L11.95,19.979l-1.53,1.255-.127.127a2.49,2.49,0,0,0-.071,3.174,2.585,2.585,0,0,0,2.123.945H28.038a.942.942,0,1,0,0-1.883H12.2a.613.613,0,0,1-.529-.324.633.633,0,0,1,0-.614l2.264-1.883H28.447a.938.938,0,0,0,.938-.712L32.4,7.834A.937.937,0,0,0,32.185,7.037Z"
                      transform="translate(398.939 -575.028)"
                      fill="none"
                    ></path>
                    <path
                      id="Path_296"
                      data-name="Path 296"
                      d="M0,0H33.853V33.853H0Z"
                      transform="translate(400 -574)"
                      fill="none"
                    ></path>
                  </g>
                </svg>
              </Nav.Link>
            </LinkContainer>
          )
        ) : (
          <LinkContainer
            to={``}
            onClick={() => {
              ReactGA.event({
                category: "Click on cart",
                action: "Click",
                value: "Click on cart",
              });
            }}
          >
            <Nav.Link className="cart-container mr-2" style={{ opacity: 0 }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33.853"
                height="33.853"
                viewBox="0 0 33.853 33.853"
                style={{ opacity: 0 }}
              >
                <g
                  id="Group_37949"
                  data-name="Group 37949"
                  transform="translate(-400 574)"
                >
                  <path
                    id="Path_292"
                    data-name="Path 292"
                    d="M19.367,38.349A2.349,2.349,0,1,1,17.019,36,2.354,2.354,0,0,1,19.367,38.349Z"
                    transform="translate(395.676 -584.61)"
                    fill="none"
                  ></path>
                  <path
                    id="Path_293"
                    data-name="Path 293"
                    d="M36.7,38.349A2.352,2.352,0,1,1,34.349,36,2.36,2.36,0,0,1,36.7,38.349Z"
                    transform="translate(390.569 -584.61)"
                    fill="none"
                  ></path>
                  <path
                    id="Path_294"
                    data-name="Path 294"
                    d="M32.185,7.037a.929.929,0,0,0-.741-.367H9.722L9.3,5.324a.922.922,0,0,0-.621-.607L4.82,3.532a.944.944,0,1,0-.55,1.806l3.371,1.03L11.95,19.979l-1.53,1.255-.127.127a2.49,2.49,0,0,0-.071,3.174,2.585,2.585,0,0,0,2.123.945H28.038a.942.942,0,1,0,0-1.883H12.2a.613.613,0,0,1-.529-.324.633.633,0,0,1,0-.614l2.264-1.883H28.447a.938.938,0,0,0,.938-.712L32.4,7.834A.937.937,0,0,0,32.185,7.037Z"
                    transform="translate(398.939 -575.028)"
                    fill="none"
                  ></path>
                  <path
                    id="Path_296"
                    data-name="Path 296"
                    d="M0,0H33.853V33.853H0Z"
                    transform="translate(400 -574)"
                    fill="none"
                  ></path>
                </g>
              </svg>
            </Nav.Link>
          </LinkContainer>
        )}
      </Navbar>
    </>
  );
}
export default HeaderInner;
